import { Theme } from '@mui/material/styles';
import { createContext } from 'react';

type ThemeContextType = {
     theme: Theme;
     toggleTheme: () => void;
     resetToSystemTheme: () => void;
     isDarkMode: boolean;
     isSystemTheme: boolean;
};

export const ThemeContext = createContext<ThemeContextType | undefined>(undefined);
